import React from 'react';
import BEM from '../../bem';
import { ReactComponent as CheckMarkIcon } from '../../../common/images/check-mark.svg';

const classes = BEM.with('MessageTaskAffordance');

type MessageTaskAffordanceProps = {
  onClick: () => void;
};

/**
 * "Create Task" affordance shown on message hover (see hover-state mockups).
 * Visibility on hover is handled in SCSS via the message row's hover state.
 */
export default function MessageTaskAffordance({ onClick }: MessageTaskAffordanceProps) {
  return (
    <button
      aria-label="Create Task"
      className={classes()}
      data-test-id="message-task-affordance"
      onClick={onClick}
      title="Create Task"
      type="button"
    >
      <CheckMarkIcon aria-hidden className={classes('icon')} />
    </button>
  );
}
